.notification-bell {
  position: relative;

  &__icon {
    --ds-icon-width: var(--cxsShell_NavigationIconSize);
    --ds-icon-heigh: var(--cxsShell_NavigationIconSize);
    --ds-icon-color: var(--cxsShell_TextColor);

    &:hover:not(:active) {
      --ds-icon-color: var(--cxsShell_Hover_TextColor);
    }
  }
}
